import { render, staticRenderFns } from "./EditSubmissionModal.vue?vue&type=template&id=f939e5e2&scoped=true&lang=pug"
import script from "./EditSubmissionModal.vue?vue&type=script&lang=js"
export * from "./EditSubmissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f939e5e2",
  null
  
)

export default component.exports